import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button, Result } from "antd";

/** Global error boundary so a render error shows a recovery screen instead of a blank app. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error("[admin2] render error", error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Result status="error" title="Something went wrong"
        subTitle={this.state.error.message}
        extra={<Button type="primary" onClick={() => location.reload()}>Reload</Button>} />
    );
  }
}
